import { Controller } from "@hotwired/stimulus"
import React from "react"
import { createRoot } from "react-dom/client"
import * as Components from "../react_components"

export default class extends Controller {
  connect() {
    const name = this.element.dataset.reactComponent
    const props = JSON.parse(this.element.dataset.reactProps || "{}")
    const Component = Components[name]
    if (!Component) return

    this.root = createRoot(this.element)
    this.root.render(<Component {...props} />)
  }

  disconnect() {
    this.root?.unmount()
  }
}
